import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigDropboxSettings } from "./app-settings-config-dropbox";

export interface IConfigDropboxInputState {
  showModal: boolean;
  editingDropboxId: string;
}

export interface IConfigDropboxInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigDropboxInput extends PureComponent<IConfigDropboxInputProps, IConfigDropboxInputState> {
  formInputName: string[] = ["apiConfig", "dropboxSettingsId"];

  constructor(props: IConfigDropboxInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingDropboxId: ""
    };
  }

  openModal = (): void => {
    this.setState({ showModal: true, editingDropboxId: "" });
  };

  closeModal = (): void => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string): void => {
    this.setState({ editingDropboxId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render(): ReactNode {
    return (
      <>
        <ConfigDropboxSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingDropboxId={this.state.editingDropboxId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Dropbox"
          formInputName={this.formInputName}
          options={this.props.commonSettings.dropboxSettings ?? []}
          allowClear
          tooltipContentKey="appsettings_mcp_dropbox"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appSettingsMcpDropboxDropdown"
          addNewTestId="appSettingsMcpDropboxAddNewButton"
          editTestId="appSettingsMcpDropboxEditButton"
        />
      </>
    );
  }
}
